import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIconComponent } from './u-icon.component';
import { IconDirective } from '../../directives/icon.directive';
import { ImgFallbackDirective } from '../../directives/img-fallback.directive';
import { SvgRendererDirective } from '../../directives/svg-renderer.directive';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { ContentCacheService } from '../../services/svg-content.service';

const directives = [ImgFallbackDirective, IconDirective, SvgRendererDirective];

@NgModule({
  declarations: [...directives, UIconComponent],
  imports: [CommonModule, LottieComponent],
  exports: [...directives, UIconComponent],
  providers: [
    ContentCacheService,
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class UIconModule {}
